// extracted by mini-css-extract-plugin
export default {"sidebarNavLink":"SidebarNavLink_sidebarNavLink__GSrWO","count":"SidebarNavLink_count__TR9f2","sidebarNavLinkActive":"SidebarNavLink_sidebarNavLinkActive__35lJv"};